import { Skeleton } from '../../Skeleton'

import * as styles from './WidgetContentSkeleton.module.css'

function WidgetContentSkeleton({ className = styles.WidgetContentSkeleton }) {
  return (
    <div className={className}>
      <Skeleton className={styles.title} />
      <Skeleton className={styles.list} />
    </div>
  )
}

export default WidgetContentSkeleton
